import { service } from '../api/axios';
import { AxiosResponse } from 'axios';

export const getAllActivityService = async (page: number) => {
  const response = await service.get('/activities', {
    params: {
      page,
    },
  });
  return response.data;
};

export const getFollowedActivityService = (): Promise<AxiosResponse> => {
  return service
    .get('/followedActivities')
    .then((responseFromAPI) => responseFromAPI.data);
};
